// source: market.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var common_pb = require('./common_pb.js');
goog.object.extend(proto, common_pb);
var enum_pb = require('./enum_pb.js');
goog.object.extend(proto, enum_pb);
goog.exportSymbol('proto.market.GetGasPriceReply', null, global);
goog.exportSymbol('proto.market.GetGasPriceRequest', null, global);
goog.exportSymbol('proto.market.GetHoldersReply', null, global);
goog.exportSymbol('proto.market.GetHoldersReplyItem', null, global);
goog.exportSymbol('proto.market.GetHoldersRequest', null, global);
goog.exportSymbol('proto.market.GetHoldersRequest.AddressCase', null, global);
goog.exportSymbol('proto.market.GetKlinesReply', null, global);
goog.exportSymbol('proto.market.GetKlinesRequest', null, global);
goog.exportSymbol('proto.market.GetKlinesRequest.AddressCase', null, global);
goog.exportSymbol('proto.market.GetMarketReply', null, global);
goog.exportSymbol('proto.market.GetMarketRequest', null, global);
goog.exportSymbol('proto.market.GetMarketRequest.AddressCase', null, global);
goog.exportSymbol('proto.market.GetMarketsFilters', null, global);
goog.exportSymbol('proto.market.GetMarketsReply', null, global);
goog.exportSymbol('proto.market.GetMarketsReplyItem', null, global);
goog.exportSymbol('proto.market.GetMarketsRequest', null, global);
goog.exportSymbol('proto.market.GetRatesReply', null, global);
goog.exportSymbol('proto.market.GetRatesRequest', null, global);
goog.exportSymbol('proto.market.GetTransactionsReply', null, global);
goog.exportSymbol('proto.market.GetTransactionsReplyItem', null, global);
goog.exportSymbol('proto.market.GetTransactionsRequest', null, global);
goog.exportSymbol('proto.market.GetTransactionsRequest.AddressCase', null, global);
goog.exportSymbol('proto.market.KlinesItem', null, global);
goog.exportSymbol('proto.market.SearchMarketsReply', null, global);
goog.exportSymbol('proto.market.SearchMarketsReplyItem', null, global);
goog.exportSymbol('proto.market.SearchMarketsRequest', null, global);
goog.exportSymbol('proto.market.TokenLinks', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.market.GetMarketsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.market.GetMarketsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.market.GetMarketsRequest.displayName = 'proto.market.GetMarketsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.market.GetMarketsFilters = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.market.GetMarketsFilters, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.market.GetMarketsFilters.displayName = 'proto.market.GetMarketsFilters';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.market.GetMarketsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.market.GetMarketsReply.repeatedFields_, null);
};
goog.inherits(proto.market.GetMarketsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.market.GetMarketsReply.displayName = 'proto.market.GetMarketsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.market.GetMarketsReplyItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.market.GetMarketsReplyItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.market.GetMarketsReplyItem.displayName = 'proto.market.GetMarketsReplyItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.market.GetMarketRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.market.GetMarketRequest.oneofGroups_);
};
goog.inherits(proto.market.GetMarketRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.market.GetMarketRequest.displayName = 'proto.market.GetMarketRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.market.GetMarketReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.market.GetMarketReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.market.GetMarketReply.displayName = 'proto.market.GetMarketReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.market.TokenLinks = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.market.TokenLinks, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.market.TokenLinks.displayName = 'proto.market.TokenLinks';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.market.GetKlinesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.market.GetKlinesRequest.oneofGroups_);
};
goog.inherits(proto.market.GetKlinesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.market.GetKlinesRequest.displayName = 'proto.market.GetKlinesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.market.GetKlinesReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.market.GetKlinesReply.repeatedFields_, null);
};
goog.inherits(proto.market.GetKlinesReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.market.GetKlinesReply.displayName = 'proto.market.GetKlinesReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.market.KlinesItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.market.KlinesItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.market.KlinesItem.displayName = 'proto.market.KlinesItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.market.GetHoldersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.market.GetHoldersRequest.oneofGroups_);
};
goog.inherits(proto.market.GetHoldersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.market.GetHoldersRequest.displayName = 'proto.market.GetHoldersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.market.GetHoldersReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.market.GetHoldersReply.repeatedFields_, null);
};
goog.inherits(proto.market.GetHoldersReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.market.GetHoldersReply.displayName = 'proto.market.GetHoldersReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.market.GetHoldersReplyItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.market.GetHoldersReplyItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.market.GetHoldersReplyItem.displayName = 'proto.market.GetHoldersReplyItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.market.GetTransactionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.market.GetTransactionsRequest.oneofGroups_);
};
goog.inherits(proto.market.GetTransactionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.market.GetTransactionsRequest.displayName = 'proto.market.GetTransactionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.market.GetTransactionsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.market.GetTransactionsReply.repeatedFields_, null);
};
goog.inherits(proto.market.GetTransactionsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.market.GetTransactionsReply.displayName = 'proto.market.GetTransactionsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.market.GetTransactionsReplyItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.market.GetTransactionsReplyItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.market.GetTransactionsReplyItem.displayName = 'proto.market.GetTransactionsReplyItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.market.GetRatesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.market.GetRatesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.market.GetRatesRequest.displayName = 'proto.market.GetRatesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.market.GetRatesReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.market.GetRatesReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.market.GetRatesReply.displayName = 'proto.market.GetRatesReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.market.GetGasPriceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.market.GetGasPriceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.market.GetGasPriceRequest.displayName = 'proto.market.GetGasPriceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.market.GetGasPriceReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.market.GetGasPriceReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.market.GetGasPriceReply.displayName = 'proto.market.GetGasPriceReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.market.SearchMarketsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.market.SearchMarketsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.market.SearchMarketsRequest.displayName = 'proto.market.SearchMarketsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.market.SearchMarketsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.market.SearchMarketsReply.repeatedFields_, null);
};
goog.inherits(proto.market.SearchMarketsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.market.SearchMarketsReply.displayName = 'proto.market.SearchMarketsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.market.SearchMarketsReplyItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.market.SearchMarketsReplyItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.market.SearchMarketsReplyItem.displayName = 'proto.market.SearchMarketsReplyItem';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.market.GetMarketsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.market.GetMarketsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.market.GetMarketsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetMarketsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    chain: jspb.Message.getFieldWithDefault(msg, 1, 0),
    filters: (f = msg.getFilters()) && proto.market.GetMarketsFilters.toObject(includeInstance, f),
    sort: jspb.Message.getFieldWithDefault(msg, 3, 0),
    desc: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    paging: (f = msg.getPaging()) && common_pb.KeyPagingRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.market.GetMarketsRequest}
 */
proto.market.GetMarketsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.market.GetMarketsRequest;
  return proto.market.GetMarketsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.market.GetMarketsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.market.GetMarketsRequest}
 */
proto.market.GetMarketsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.enumeration.Chain} */ (reader.readEnum());
      msg.setChain(value);
      break;
    case 2:
      var value = new proto.market.GetMarketsFilters;
      reader.readMessage(value,proto.market.GetMarketsFilters.deserializeBinaryFromReader);
      msg.setFilters(value);
      break;
    case 3:
      var value = /** @type {!proto.enumeration.MarketsSort} */ (reader.readEnum());
      msg.setSort(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDesc(value);
      break;
    case 5:
      var value = new common_pb.KeyPagingRequest;
      reader.readMessage(value,common_pb.KeyPagingRequest.deserializeBinaryFromReader);
      msg.setPaging(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.market.GetMarketsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.market.GetMarketsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.market.GetMarketsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetMarketsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChain();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getFilters();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.market.GetMarketsFilters.serializeBinaryToWriter
    );
  }
  f = /** @type {!proto.enumeration.MarketsSort} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getPaging();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      common_pb.KeyPagingRequest.serializeBinaryToWriter
    );
  }
};


/**
 * optional enumeration.Chain chain = 1;
 * @return {!proto.enumeration.Chain}
 */
proto.market.GetMarketsRequest.prototype.getChain = function() {
  return /** @type {!proto.enumeration.Chain} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.enumeration.Chain} value
 * @return {!proto.market.GetMarketsRequest} returns this
 */
proto.market.GetMarketsRequest.prototype.setChain = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional GetMarketsFilters filters = 2;
 * @return {?proto.market.GetMarketsFilters}
 */
proto.market.GetMarketsRequest.prototype.getFilters = function() {
  return /** @type{?proto.market.GetMarketsFilters} */ (
    jspb.Message.getWrapperField(this, proto.market.GetMarketsFilters, 2));
};


/**
 * @param {?proto.market.GetMarketsFilters|undefined} value
 * @return {!proto.market.GetMarketsRequest} returns this
*/
proto.market.GetMarketsRequest.prototype.setFilters = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetMarketsRequest} returns this
 */
proto.market.GetMarketsRequest.prototype.clearFilters = function() {
  return this.setFilters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsRequest.prototype.hasFilters = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional enumeration.MarketsSort sort = 3;
 * @return {!proto.enumeration.MarketsSort}
 */
proto.market.GetMarketsRequest.prototype.getSort = function() {
  return /** @type {!proto.enumeration.MarketsSort} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.enumeration.MarketsSort} value
 * @return {!proto.market.GetMarketsRequest} returns this
 */
proto.market.GetMarketsRequest.prototype.setSort = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.market.GetMarketsRequest} returns this
 */
proto.market.GetMarketsRequest.prototype.clearSort = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsRequest.prototype.hasSort = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool desc = 4;
 * @return {boolean}
 */
proto.market.GetMarketsRequest.prototype.getDesc = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.market.GetMarketsRequest} returns this
 */
proto.market.GetMarketsRequest.prototype.setDesc = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.market.GetMarketsRequest} returns this
 */
proto.market.GetMarketsRequest.prototype.clearDesc = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsRequest.prototype.hasDesc = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional common.KeyPagingRequest paging = 5;
 * @return {?proto.common.KeyPagingRequest}
 */
proto.market.GetMarketsRequest.prototype.getPaging = function() {
  return /** @type{?proto.common.KeyPagingRequest} */ (
    jspb.Message.getWrapperField(this, common_pb.KeyPagingRequest, 5));
};


/**
 * @param {?proto.common.KeyPagingRequest|undefined} value
 * @return {!proto.market.GetMarketsRequest} returns this
*/
proto.market.GetMarketsRequest.prototype.setPaging = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetMarketsRequest} returns this
 */
proto.market.GetMarketsRequest.prototype.clearPaging = function() {
  return this.setPaging(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsRequest.prototype.hasPaging = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.market.GetMarketsFilters.prototype.toObject = function(opt_includeInstance) {
  return proto.market.GetMarketsFilters.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.market.GetMarketsFilters} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetMarketsFilters.toObject = function(includeInstance, msg) {
  var f, obj = {
    mininitialliquidity: (f = msg.getMininitialliquidity()) && common_pb.Decimals.toObject(includeInstance, f),
    maxinitialliquidity: (f = msg.getMaxinitialliquidity()) && common_pb.Decimals.toObject(includeInstance, f),
    minliquidity: (f = msg.getMinliquidity()) && common_pb.Decimals.toObject(includeInstance, f),
    maxliquidity: (f = msg.getMaxliquidity()) && common_pb.Decimals.toObject(includeInstance, f),
    mintxcount: jspb.Message.getFieldWithDefault(msg, 5, 0),
    maxtxcount: jspb.Message.getFieldWithDefault(msg, 6, 0),
    mintradevolume: (f = msg.getMintradevolume()) && common_pb.Decimals.toObject(includeInstance, f),
    maxtradevolume: (f = msg.getMaxtradevolume()) && common_pb.Decimals.toObject(includeInstance, f),
    minmarketcap: (f = msg.getMinmarketcap()) && common_pb.Decimals.toObject(includeInstance, f),
    maxmarketcap: (f = msg.getMaxmarketcap()) && common_pb.Decimals.toObject(includeInstance, f),
    mintauthority: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    freezeauthority: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    lpburned: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
    topholders: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
    verifiedcontract: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
    lockedliquidity: jspb.Message.getBooleanFieldWithDefault(msg, 16, false),
    renounced: jspb.Message.getBooleanFieldWithDefault(msg, 17, false),
    honeypot: jspb.Message.getBooleanFieldWithDefault(msg, 18, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.market.GetMarketsFilters}
 */
proto.market.GetMarketsFilters.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.market.GetMarketsFilters;
  return proto.market.GetMarketsFilters.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.market.GetMarketsFilters} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.market.GetMarketsFilters}
 */
proto.market.GetMarketsFilters.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setMininitialliquidity(value);
      break;
    case 2:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setMaxinitialliquidity(value);
      break;
    case 3:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setMinliquidity(value);
      break;
    case 4:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setMaxliquidity(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setMintxcount(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setMaxtxcount(value);
      break;
    case 7:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setMintradevolume(value);
      break;
    case 8:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setMaxtradevolume(value);
      break;
    case 9:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setMinmarketcap(value);
      break;
    case 10:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setMaxmarketcap(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMintauthority(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFreezeauthority(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLpburned(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTopholders(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVerifiedcontract(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLockedliquidity(value);
      break;
    case 17:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRenounced(value);
      break;
    case 18:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHoneypot(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.market.GetMarketsFilters.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.market.GetMarketsFilters.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.market.GetMarketsFilters} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetMarketsFilters.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMininitialliquidity();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getMaxinitialliquidity();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getMinliquidity();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getMaxliquidity();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeUint64(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeUint64(
      6,
      f
    );
  }
  f = message.getMintradevolume();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getMaxtradevolume();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getMinmarketcap();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getMaxmarketcap();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeBool(
      11,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeBool(
      12,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeBool(
      13,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 14));
  if (f != null) {
    writer.writeBool(
      14,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 15));
  if (f != null) {
    writer.writeBool(
      15,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 16));
  if (f != null) {
    writer.writeBool(
      16,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 17));
  if (f != null) {
    writer.writeBool(
      17,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 18));
  if (f != null) {
    writer.writeBool(
      18,
      f
    );
  }
};


/**
 * optional common.Decimals minInitialLiquidity = 1;
 * @return {?proto.common.Decimals}
 */
proto.market.GetMarketsFilters.prototype.getMininitialliquidity = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 1));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.GetMarketsFilters} returns this
*/
proto.market.GetMarketsFilters.prototype.setMininitialliquidity = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetMarketsFilters} returns this
 */
proto.market.GetMarketsFilters.prototype.clearMininitialliquidity = function() {
  return this.setMininitialliquidity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsFilters.prototype.hasMininitialliquidity = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.Decimals maxInitialLiquidity = 2;
 * @return {?proto.common.Decimals}
 */
proto.market.GetMarketsFilters.prototype.getMaxinitialliquidity = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 2));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.GetMarketsFilters} returns this
*/
proto.market.GetMarketsFilters.prototype.setMaxinitialliquidity = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetMarketsFilters} returns this
 */
proto.market.GetMarketsFilters.prototype.clearMaxinitialliquidity = function() {
  return this.setMaxinitialliquidity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsFilters.prototype.hasMaxinitialliquidity = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional common.Decimals minLiquidity = 3;
 * @return {?proto.common.Decimals}
 */
proto.market.GetMarketsFilters.prototype.getMinliquidity = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 3));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.GetMarketsFilters} returns this
*/
proto.market.GetMarketsFilters.prototype.setMinliquidity = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetMarketsFilters} returns this
 */
proto.market.GetMarketsFilters.prototype.clearMinliquidity = function() {
  return this.setMinliquidity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsFilters.prototype.hasMinliquidity = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional common.Decimals maxLiquidity = 4;
 * @return {?proto.common.Decimals}
 */
proto.market.GetMarketsFilters.prototype.getMaxliquidity = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 4));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.GetMarketsFilters} returns this
*/
proto.market.GetMarketsFilters.prototype.setMaxliquidity = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetMarketsFilters} returns this
 */
proto.market.GetMarketsFilters.prototype.clearMaxliquidity = function() {
  return this.setMaxliquidity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsFilters.prototype.hasMaxliquidity = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional uint64 minTxCount = 5;
 * @return {number}
 */
proto.market.GetMarketsFilters.prototype.getMintxcount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.market.GetMarketsFilters} returns this
 */
proto.market.GetMarketsFilters.prototype.setMintxcount = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.market.GetMarketsFilters} returns this
 */
proto.market.GetMarketsFilters.prototype.clearMintxcount = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsFilters.prototype.hasMintxcount = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional uint64 maxTxCount = 6;
 * @return {number}
 */
proto.market.GetMarketsFilters.prototype.getMaxtxcount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.market.GetMarketsFilters} returns this
 */
proto.market.GetMarketsFilters.prototype.setMaxtxcount = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.market.GetMarketsFilters} returns this
 */
proto.market.GetMarketsFilters.prototype.clearMaxtxcount = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsFilters.prototype.hasMaxtxcount = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional common.Decimals minTradeVolume = 7;
 * @return {?proto.common.Decimals}
 */
proto.market.GetMarketsFilters.prototype.getMintradevolume = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 7));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.GetMarketsFilters} returns this
*/
proto.market.GetMarketsFilters.prototype.setMintradevolume = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetMarketsFilters} returns this
 */
proto.market.GetMarketsFilters.prototype.clearMintradevolume = function() {
  return this.setMintradevolume(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsFilters.prototype.hasMintradevolume = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional common.Decimals maxTradeVolume = 8;
 * @return {?proto.common.Decimals}
 */
proto.market.GetMarketsFilters.prototype.getMaxtradevolume = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 8));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.GetMarketsFilters} returns this
*/
proto.market.GetMarketsFilters.prototype.setMaxtradevolume = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetMarketsFilters} returns this
 */
proto.market.GetMarketsFilters.prototype.clearMaxtradevolume = function() {
  return this.setMaxtradevolume(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsFilters.prototype.hasMaxtradevolume = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional common.Decimals minMarketCap = 9;
 * @return {?proto.common.Decimals}
 */
proto.market.GetMarketsFilters.prototype.getMinmarketcap = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 9));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.GetMarketsFilters} returns this
*/
proto.market.GetMarketsFilters.prototype.setMinmarketcap = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetMarketsFilters} returns this
 */
proto.market.GetMarketsFilters.prototype.clearMinmarketcap = function() {
  return this.setMinmarketcap(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsFilters.prototype.hasMinmarketcap = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional common.Decimals maxMarketCap = 10;
 * @return {?proto.common.Decimals}
 */
proto.market.GetMarketsFilters.prototype.getMaxmarketcap = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 10));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.GetMarketsFilters} returns this
*/
proto.market.GetMarketsFilters.prototype.setMaxmarketcap = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetMarketsFilters} returns this
 */
proto.market.GetMarketsFilters.prototype.clearMaxmarketcap = function() {
  return this.setMaxmarketcap(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsFilters.prototype.hasMaxmarketcap = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional bool mintAuthority = 11;
 * @return {boolean}
 */
proto.market.GetMarketsFilters.prototype.getMintauthority = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.market.GetMarketsFilters} returns this
 */
proto.market.GetMarketsFilters.prototype.setMintauthority = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.market.GetMarketsFilters} returns this
 */
proto.market.GetMarketsFilters.prototype.clearMintauthority = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsFilters.prototype.hasMintauthority = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional bool freezeAuthority = 12;
 * @return {boolean}
 */
proto.market.GetMarketsFilters.prototype.getFreezeauthority = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.market.GetMarketsFilters} returns this
 */
proto.market.GetMarketsFilters.prototype.setFreezeauthority = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.market.GetMarketsFilters} returns this
 */
proto.market.GetMarketsFilters.prototype.clearFreezeauthority = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsFilters.prototype.hasFreezeauthority = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional bool lpBurned = 13;
 * @return {boolean}
 */
proto.market.GetMarketsFilters.prototype.getLpburned = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.market.GetMarketsFilters} returns this
 */
proto.market.GetMarketsFilters.prototype.setLpburned = function(value) {
  return jspb.Message.setField(this, 13, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.market.GetMarketsFilters} returns this
 */
proto.market.GetMarketsFilters.prototype.clearLpburned = function() {
  return jspb.Message.setField(this, 13, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsFilters.prototype.hasLpburned = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional bool topHolders = 14;
 * @return {boolean}
 */
proto.market.GetMarketsFilters.prototype.getTopholders = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.market.GetMarketsFilters} returns this
 */
proto.market.GetMarketsFilters.prototype.setTopholders = function(value) {
  return jspb.Message.setField(this, 14, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.market.GetMarketsFilters} returns this
 */
proto.market.GetMarketsFilters.prototype.clearTopholders = function() {
  return jspb.Message.setField(this, 14, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsFilters.prototype.hasTopholders = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional bool verifiedContract = 15;
 * @return {boolean}
 */
proto.market.GetMarketsFilters.prototype.getVerifiedcontract = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.market.GetMarketsFilters} returns this
 */
proto.market.GetMarketsFilters.prototype.setVerifiedcontract = function(value) {
  return jspb.Message.setField(this, 15, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.market.GetMarketsFilters} returns this
 */
proto.market.GetMarketsFilters.prototype.clearVerifiedcontract = function() {
  return jspb.Message.setField(this, 15, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsFilters.prototype.hasVerifiedcontract = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional bool lockedLiquidity = 16;
 * @return {boolean}
 */
proto.market.GetMarketsFilters.prototype.getLockedliquidity = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.market.GetMarketsFilters} returns this
 */
proto.market.GetMarketsFilters.prototype.setLockedliquidity = function(value) {
  return jspb.Message.setField(this, 16, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.market.GetMarketsFilters} returns this
 */
proto.market.GetMarketsFilters.prototype.clearLockedliquidity = function() {
  return jspb.Message.setField(this, 16, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsFilters.prototype.hasLockedliquidity = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional bool renounced = 17;
 * @return {boolean}
 */
proto.market.GetMarketsFilters.prototype.getRenounced = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 17, false));
};


/**
 * @param {boolean} value
 * @return {!proto.market.GetMarketsFilters} returns this
 */
proto.market.GetMarketsFilters.prototype.setRenounced = function(value) {
  return jspb.Message.setField(this, 17, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.market.GetMarketsFilters} returns this
 */
proto.market.GetMarketsFilters.prototype.clearRenounced = function() {
  return jspb.Message.setField(this, 17, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsFilters.prototype.hasRenounced = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional bool honeypot = 18;
 * @return {boolean}
 */
proto.market.GetMarketsFilters.prototype.getHoneypot = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 18, false));
};


/**
 * @param {boolean} value
 * @return {!proto.market.GetMarketsFilters} returns this
 */
proto.market.GetMarketsFilters.prototype.setHoneypot = function(value) {
  return jspb.Message.setField(this, 18, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.market.GetMarketsFilters} returns this
 */
proto.market.GetMarketsFilters.prototype.clearHoneypot = function() {
  return jspb.Message.setField(this, 18, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsFilters.prototype.hasHoneypot = function() {
  return jspb.Message.getField(this, 18) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.market.GetMarketsReply.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.market.GetMarketsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.market.GetMarketsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.market.GetMarketsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetMarketsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    result: (f = msg.getResult()) && common_pb.RequestResult.toObject(includeInstance, f),
    marketsList: jspb.Message.toObjectList(msg.getMarketsList(),
    proto.market.GetMarketsReplyItem.toObject, includeInstance),
    toremoveList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    continuationtoken: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.market.GetMarketsReply}
 */
proto.market.GetMarketsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.market.GetMarketsReply;
  return proto.market.GetMarketsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.market.GetMarketsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.market.GetMarketsReply}
 */
proto.market.GetMarketsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_pb.RequestResult;
      reader.readMessage(value,common_pb.RequestResult.deserializeBinaryFromReader);
      msg.setResult(value);
      break;
    case 2:
      var value = new proto.market.GetMarketsReplyItem;
      reader.readMessage(value,proto.market.GetMarketsReplyItem.deserializeBinaryFromReader);
      msg.addMarkets(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addToremove(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setContinuationtoken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.market.GetMarketsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.market.GetMarketsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.market.GetMarketsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetMarketsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResult();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_pb.RequestResult.serializeBinaryToWriter
    );
  }
  f = message.getMarketsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.market.GetMarketsReplyItem.serializeBinaryToWriter
    );
  }
  f = message.getToremoveList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional common.RequestResult result = 1;
 * @return {?proto.common.RequestResult}
 */
proto.market.GetMarketsReply.prototype.getResult = function() {
  return /** @type{?proto.common.RequestResult} */ (
    jspb.Message.getWrapperField(this, common_pb.RequestResult, 1));
};


/**
 * @param {?proto.common.RequestResult|undefined} value
 * @return {!proto.market.GetMarketsReply} returns this
*/
proto.market.GetMarketsReply.prototype.setResult = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetMarketsReply} returns this
 */
proto.market.GetMarketsReply.prototype.clearResult = function() {
  return this.setResult(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsReply.prototype.hasResult = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated GetMarketsReplyItem markets = 2;
 * @return {!Array<!proto.market.GetMarketsReplyItem>}
 */
proto.market.GetMarketsReply.prototype.getMarketsList = function() {
  return /** @type{!Array<!proto.market.GetMarketsReplyItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.market.GetMarketsReplyItem, 2));
};


/**
 * @param {!Array<!proto.market.GetMarketsReplyItem>} value
 * @return {!proto.market.GetMarketsReply} returns this
*/
proto.market.GetMarketsReply.prototype.setMarketsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.market.GetMarketsReplyItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.market.GetMarketsReplyItem}
 */
proto.market.GetMarketsReply.prototype.addMarkets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.market.GetMarketsReplyItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.market.GetMarketsReply} returns this
 */
proto.market.GetMarketsReply.prototype.clearMarketsList = function() {
  return this.setMarketsList([]);
};


/**
 * repeated string toRemove = 3;
 * @return {!Array<string>}
 */
proto.market.GetMarketsReply.prototype.getToremoveList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.market.GetMarketsReply} returns this
 */
proto.market.GetMarketsReply.prototype.setToremoveList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.market.GetMarketsReply} returns this
 */
proto.market.GetMarketsReply.prototype.addToremove = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.market.GetMarketsReply} returns this
 */
proto.market.GetMarketsReply.prototype.clearToremoveList = function() {
  return this.setToremoveList([]);
};


/**
 * optional string continuationToken = 4;
 * @return {string}
 */
proto.market.GetMarketsReply.prototype.getContinuationtoken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.market.GetMarketsReply} returns this
 */
proto.market.GetMarketsReply.prototype.setContinuationtoken = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.market.GetMarketsReply} returns this
 */
proto.market.GetMarketsReply.prototype.clearContinuationtoken = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsReply.prototype.hasContinuationtoken = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.market.GetMarketsReplyItem.prototype.toObject = function(opt_includeInstance) {
  return proto.market.GetMarketsReplyItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.market.GetMarketsReplyItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetMarketsReplyItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    pooladdress: jspb.Message.getFieldWithDefault(msg, 1, ""),
    tokenaddress: jspb.Message.getFieldWithDefault(msg, 2, ""),
    tokenname: jspb.Message.getFieldWithDefault(msg, 3, ""),
    tokenticker: jspb.Message.getFieldWithDefault(msg, 4, ""),
    createdat: (f = msg.getCreatedat()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    price: (f = msg.getPrice()) && common_pb.Decimals.toObject(includeInstance, f),
    initialliquidity: (f = msg.getInitialliquidity()) && common_pb.Decimals.toObject(includeInstance, f),
    liquidity: (f = msg.getLiquidity()) && common_pb.Decimals.toObject(includeInstance, f),
    liquiditychangepct: (f = msg.getLiquiditychangepct()) && common_pb.Decimals.toObject(includeInstance, f),
    marketcap: (f = msg.getMarketcap()) && common_pb.Decimals.toObject(includeInstance, f),
    buytxcount: jspb.Message.getFieldWithDefault(msg, 11, 0),
    selltxcount: jspb.Message.getFieldWithDefault(msg, 12, 0),
    tradevolume: (f = msg.getTradevolume()) && common_pb.Decimals.toObject(includeInstance, f),
    audit: (f = msg.getAudit()) && common_pb.AuditReply.toObject(includeInstance, f),
    pricechangepct5m: (f = msg.getPricechangepct5m()) && common_pb.Decimals.toObject(includeInstance, f),
    pricechangepct1h: (f = msg.getPricechangepct1h()) && common_pb.Decimals.toObject(includeInstance, f),
    pricechangepct6h: (f = msg.getPricechangepct6h()) && common_pb.Decimals.toObject(includeInstance, f),
    pricechangepct24h: (f = msg.getPricechangepct24h()) && common_pb.Decimals.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.market.GetMarketsReplyItem}
 */
proto.market.GetMarketsReplyItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.market.GetMarketsReplyItem;
  return proto.market.GetMarketsReplyItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.market.GetMarketsReplyItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.market.GetMarketsReplyItem}
 */
proto.market.GetMarketsReplyItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPooladdress(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTokenaddress(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTokenname(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTokenticker(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedat(value);
      break;
    case 6:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setPrice(value);
      break;
    case 7:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setInitialliquidity(value);
      break;
    case 8:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setLiquidity(value);
      break;
    case 9:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setLiquiditychangepct(value);
      break;
    case 10:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setMarketcap(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setBuytxcount(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSelltxcount(value);
      break;
    case 13:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setTradevolume(value);
      break;
    case 14:
      var value = new common_pb.AuditReply;
      reader.readMessage(value,common_pb.AuditReply.deserializeBinaryFromReader);
      msg.setAudit(value);
      break;
    case 15:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setPricechangepct5m(value);
      break;
    case 16:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setPricechangepct1h(value);
      break;
    case 17:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setPricechangepct6h(value);
      break;
    case 18:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setPricechangepct24h(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.market.GetMarketsReplyItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.market.GetMarketsReplyItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.market.GetMarketsReplyItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetMarketsReplyItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPooladdress();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTokenaddress();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTokenname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTokenticker();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCreatedat();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPrice();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getInitialliquidity();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getLiquidity();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getLiquiditychangepct();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getMarketcap();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getBuytxcount();
  if (f !== 0) {
    writer.writeUint32(
      11,
      f
    );
  }
  f = message.getSelltxcount();
  if (f !== 0) {
    writer.writeUint32(
      12,
      f
    );
  }
  f = message.getTradevolume();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getAudit();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      common_pb.AuditReply.serializeBinaryToWriter
    );
  }
  f = message.getPricechangepct5m();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getPricechangepct1h();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getPricechangepct6h();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getPricechangepct24h();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
};


/**
 * optional string poolAddress = 1;
 * @return {string}
 */
proto.market.GetMarketsReplyItem.prototype.getPooladdress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.market.GetMarketsReplyItem} returns this
 */
proto.market.GetMarketsReplyItem.prototype.setPooladdress = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string tokenAddress = 2;
 * @return {string}
 */
proto.market.GetMarketsReplyItem.prototype.getTokenaddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.market.GetMarketsReplyItem} returns this
 */
proto.market.GetMarketsReplyItem.prototype.setTokenaddress = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string tokenName = 3;
 * @return {string}
 */
proto.market.GetMarketsReplyItem.prototype.getTokenname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.market.GetMarketsReplyItem} returns this
 */
proto.market.GetMarketsReplyItem.prototype.setTokenname = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string tokenTicker = 4;
 * @return {string}
 */
proto.market.GetMarketsReplyItem.prototype.getTokenticker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.market.GetMarketsReplyItem} returns this
 */
proto.market.GetMarketsReplyItem.prototype.setTokenticker = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp createdAt = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.market.GetMarketsReplyItem.prototype.getCreatedat = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.market.GetMarketsReplyItem} returns this
*/
proto.market.GetMarketsReplyItem.prototype.setCreatedat = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetMarketsReplyItem} returns this
 */
proto.market.GetMarketsReplyItem.prototype.clearCreatedat = function() {
  return this.setCreatedat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsReplyItem.prototype.hasCreatedat = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional common.Decimals price = 6;
 * @return {?proto.common.Decimals}
 */
proto.market.GetMarketsReplyItem.prototype.getPrice = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 6));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.GetMarketsReplyItem} returns this
*/
proto.market.GetMarketsReplyItem.prototype.setPrice = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetMarketsReplyItem} returns this
 */
proto.market.GetMarketsReplyItem.prototype.clearPrice = function() {
  return this.setPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsReplyItem.prototype.hasPrice = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional common.Decimals initialLiquidity = 7;
 * @return {?proto.common.Decimals}
 */
proto.market.GetMarketsReplyItem.prototype.getInitialliquidity = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 7));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.GetMarketsReplyItem} returns this
*/
proto.market.GetMarketsReplyItem.prototype.setInitialliquidity = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetMarketsReplyItem} returns this
 */
proto.market.GetMarketsReplyItem.prototype.clearInitialliquidity = function() {
  return this.setInitialliquidity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsReplyItem.prototype.hasInitialliquidity = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional common.Decimals liquidity = 8;
 * @return {?proto.common.Decimals}
 */
proto.market.GetMarketsReplyItem.prototype.getLiquidity = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 8));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.GetMarketsReplyItem} returns this
*/
proto.market.GetMarketsReplyItem.prototype.setLiquidity = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetMarketsReplyItem} returns this
 */
proto.market.GetMarketsReplyItem.prototype.clearLiquidity = function() {
  return this.setLiquidity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsReplyItem.prototype.hasLiquidity = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional common.Decimals liquidityChangePct = 9;
 * @return {?proto.common.Decimals}
 */
proto.market.GetMarketsReplyItem.prototype.getLiquiditychangepct = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 9));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.GetMarketsReplyItem} returns this
*/
proto.market.GetMarketsReplyItem.prototype.setLiquiditychangepct = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetMarketsReplyItem} returns this
 */
proto.market.GetMarketsReplyItem.prototype.clearLiquiditychangepct = function() {
  return this.setLiquiditychangepct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsReplyItem.prototype.hasLiquiditychangepct = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional common.Decimals marketCap = 10;
 * @return {?proto.common.Decimals}
 */
proto.market.GetMarketsReplyItem.prototype.getMarketcap = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 10));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.GetMarketsReplyItem} returns this
*/
proto.market.GetMarketsReplyItem.prototype.setMarketcap = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetMarketsReplyItem} returns this
 */
proto.market.GetMarketsReplyItem.prototype.clearMarketcap = function() {
  return this.setMarketcap(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsReplyItem.prototype.hasMarketcap = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional uint32 buyTxCount = 11;
 * @return {number}
 */
proto.market.GetMarketsReplyItem.prototype.getBuytxcount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.market.GetMarketsReplyItem} returns this
 */
proto.market.GetMarketsReplyItem.prototype.setBuytxcount = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional uint32 sellTxCount = 12;
 * @return {number}
 */
proto.market.GetMarketsReplyItem.prototype.getSelltxcount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.market.GetMarketsReplyItem} returns this
 */
proto.market.GetMarketsReplyItem.prototype.setSelltxcount = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional common.Decimals tradeVolume = 13;
 * @return {?proto.common.Decimals}
 */
proto.market.GetMarketsReplyItem.prototype.getTradevolume = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 13));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.GetMarketsReplyItem} returns this
*/
proto.market.GetMarketsReplyItem.prototype.setTradevolume = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetMarketsReplyItem} returns this
 */
proto.market.GetMarketsReplyItem.prototype.clearTradevolume = function() {
  return this.setTradevolume(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsReplyItem.prototype.hasTradevolume = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional common.AuditReply audit = 14;
 * @return {?proto.common.AuditReply}
 */
proto.market.GetMarketsReplyItem.prototype.getAudit = function() {
  return /** @type{?proto.common.AuditReply} */ (
    jspb.Message.getWrapperField(this, common_pb.AuditReply, 14));
};


/**
 * @param {?proto.common.AuditReply|undefined} value
 * @return {!proto.market.GetMarketsReplyItem} returns this
*/
proto.market.GetMarketsReplyItem.prototype.setAudit = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetMarketsReplyItem} returns this
 */
proto.market.GetMarketsReplyItem.prototype.clearAudit = function() {
  return this.setAudit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsReplyItem.prototype.hasAudit = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional common.Decimals priceChangePct5M = 15;
 * @return {?proto.common.Decimals}
 */
proto.market.GetMarketsReplyItem.prototype.getPricechangepct5m = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 15));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.GetMarketsReplyItem} returns this
*/
proto.market.GetMarketsReplyItem.prototype.setPricechangepct5m = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetMarketsReplyItem} returns this
 */
proto.market.GetMarketsReplyItem.prototype.clearPricechangepct5m = function() {
  return this.setPricechangepct5m(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsReplyItem.prototype.hasPricechangepct5m = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional common.Decimals priceChangePct1H = 16;
 * @return {?proto.common.Decimals}
 */
proto.market.GetMarketsReplyItem.prototype.getPricechangepct1h = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 16));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.GetMarketsReplyItem} returns this
*/
proto.market.GetMarketsReplyItem.prototype.setPricechangepct1h = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetMarketsReplyItem} returns this
 */
proto.market.GetMarketsReplyItem.prototype.clearPricechangepct1h = function() {
  return this.setPricechangepct1h(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsReplyItem.prototype.hasPricechangepct1h = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional common.Decimals priceChangePct6H = 17;
 * @return {?proto.common.Decimals}
 */
proto.market.GetMarketsReplyItem.prototype.getPricechangepct6h = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 17));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.GetMarketsReplyItem} returns this
*/
proto.market.GetMarketsReplyItem.prototype.setPricechangepct6h = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetMarketsReplyItem} returns this
 */
proto.market.GetMarketsReplyItem.prototype.clearPricechangepct6h = function() {
  return this.setPricechangepct6h(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsReplyItem.prototype.hasPricechangepct6h = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional common.Decimals priceChangePct24H = 18;
 * @return {?proto.common.Decimals}
 */
proto.market.GetMarketsReplyItem.prototype.getPricechangepct24h = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 18));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.GetMarketsReplyItem} returns this
*/
proto.market.GetMarketsReplyItem.prototype.setPricechangepct24h = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetMarketsReplyItem} returns this
 */
proto.market.GetMarketsReplyItem.prototype.clearPricechangepct24h = function() {
  return this.setPricechangepct24h(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketsReplyItem.prototype.hasPricechangepct24h = function() {
  return jspb.Message.getField(this, 18) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.market.GetMarketRequest.oneofGroups_ = [[2,3]];

/**
 * @enum {number}
 */
proto.market.GetMarketRequest.AddressCase = {
  ADDRESS_NOT_SET: 0,
  TOKENADDRESS: 2,
  POOLADDRESS: 3
};

/**
 * @return {proto.market.GetMarketRequest.AddressCase}
 */
proto.market.GetMarketRequest.prototype.getAddressCase = function() {
  return /** @type {proto.market.GetMarketRequest.AddressCase} */(jspb.Message.computeOneofCase(this, proto.market.GetMarketRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.market.GetMarketRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.market.GetMarketRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.market.GetMarketRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetMarketRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    chain: jspb.Message.getFieldWithDefault(msg, 1, 0),
    tokenaddress: jspb.Message.getFieldWithDefault(msg, 2, ""),
    pooladdress: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.market.GetMarketRequest}
 */
proto.market.GetMarketRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.market.GetMarketRequest;
  return proto.market.GetMarketRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.market.GetMarketRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.market.GetMarketRequest}
 */
proto.market.GetMarketRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.enumeration.Chain} */ (reader.readEnum());
      msg.setChain(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTokenaddress(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPooladdress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.market.GetMarketRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.market.GetMarketRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.market.GetMarketRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetMarketRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChain();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional enumeration.Chain chain = 1;
 * @return {!proto.enumeration.Chain}
 */
proto.market.GetMarketRequest.prototype.getChain = function() {
  return /** @type {!proto.enumeration.Chain} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.enumeration.Chain} value
 * @return {!proto.market.GetMarketRequest} returns this
 */
proto.market.GetMarketRequest.prototype.setChain = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string tokenAddress = 2;
 * @return {string}
 */
proto.market.GetMarketRequest.prototype.getTokenaddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.market.GetMarketRequest} returns this
 */
proto.market.GetMarketRequest.prototype.setTokenaddress = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.market.GetMarketRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.market.GetMarketRequest} returns this
 */
proto.market.GetMarketRequest.prototype.clearTokenaddress = function() {
  return jspb.Message.setOneofField(this, 2, proto.market.GetMarketRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketRequest.prototype.hasTokenaddress = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string poolAddress = 3;
 * @return {string}
 */
proto.market.GetMarketRequest.prototype.getPooladdress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.market.GetMarketRequest} returns this
 */
proto.market.GetMarketRequest.prototype.setPooladdress = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.market.GetMarketRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.market.GetMarketRequest} returns this
 */
proto.market.GetMarketRequest.prototype.clearPooladdress = function() {
  return jspb.Message.setOneofField(this, 3, proto.market.GetMarketRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketRequest.prototype.hasPooladdress = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.market.GetMarketReply.prototype.toObject = function(opt_includeInstance) {
  return proto.market.GetMarketReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.market.GetMarketReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetMarketReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    result: (f = msg.getResult()) && common_pb.RequestResult.toObject(includeInstance, f),
    pooladdress: jspb.Message.getFieldWithDefault(msg, 2, ""),
    tokenaddress: jspb.Message.getFieldWithDefault(msg, 3, ""),
    tokenname: jspb.Message.getFieldWithDefault(msg, 4, ""),
    tokenticker: jspb.Message.getFieldWithDefault(msg, 5, ""),
    decimals: jspb.Message.getFieldWithDefault(msg, 6, 0),
    price: (f = msg.getPrice()) && common_pb.Decimals.toObject(includeInstance, f),
    dexversion: jspb.Message.getFieldWithDefault(msg, 8, 0),
    analytics: (f = msg.getAnalytics()) && common_pb.AnalyticsReply.toObject(includeInstance, f),
    audit: (f = msg.getAudit()) && common_pb.AuditReply.toObject(includeInstance, f),
    tokenomics: (f = msg.getTokenomics()) && common_pb.Tokenomics.toObject(includeInstance, f),
    gaslimit: (f = msg.getGaslimit()) && common_pb.Decimals.toObject(includeInstance, f),
    tokenlinks: (f = msg.getTokenlinks()) && proto.market.TokenLinks.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.market.GetMarketReply}
 */
proto.market.GetMarketReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.market.GetMarketReply;
  return proto.market.GetMarketReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.market.GetMarketReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.market.GetMarketReply}
 */
proto.market.GetMarketReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_pb.RequestResult;
      reader.readMessage(value,common_pb.RequestResult.deserializeBinaryFromReader);
      msg.setResult(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPooladdress(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTokenaddress(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTokenname(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTokenticker(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDecimals(value);
      break;
    case 7:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setPrice(value);
      break;
    case 8:
      var value = /** @type {!proto.enumeration.DexVersion} */ (reader.readEnum());
      msg.setDexversion(value);
      break;
    case 9:
      var value = new common_pb.AnalyticsReply;
      reader.readMessage(value,common_pb.AnalyticsReply.deserializeBinaryFromReader);
      msg.setAnalytics(value);
      break;
    case 10:
      var value = new common_pb.AuditReply;
      reader.readMessage(value,common_pb.AuditReply.deserializeBinaryFromReader);
      msg.setAudit(value);
      break;
    case 11:
      var value = new common_pb.Tokenomics;
      reader.readMessage(value,common_pb.Tokenomics.deserializeBinaryFromReader);
      msg.setTokenomics(value);
      break;
    case 12:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setGaslimit(value);
      break;
    case 13:
      var value = new proto.market.TokenLinks;
      reader.readMessage(value,proto.market.TokenLinks.deserializeBinaryFromReader);
      msg.setTokenlinks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.market.GetMarketReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.market.GetMarketReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.market.GetMarketReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetMarketReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResult();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_pb.RequestResult.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getPrice();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
  f = /** @type {!proto.enumeration.DexVersion} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getAnalytics();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      common_pb.AnalyticsReply.serializeBinaryToWriter
    );
  }
  f = message.getAudit();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      common_pb.AuditReply.serializeBinaryToWriter
    );
  }
  f = message.getTokenomics();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      common_pb.Tokenomics.serializeBinaryToWriter
    );
  }
  f = message.getGaslimit();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getTokenlinks();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.market.TokenLinks.serializeBinaryToWriter
    );
  }
};


/**
 * optional common.RequestResult result = 1;
 * @return {?proto.common.RequestResult}
 */
proto.market.GetMarketReply.prototype.getResult = function() {
  return /** @type{?proto.common.RequestResult} */ (
    jspb.Message.getWrapperField(this, common_pb.RequestResult, 1));
};


/**
 * @param {?proto.common.RequestResult|undefined} value
 * @return {!proto.market.GetMarketReply} returns this
*/
proto.market.GetMarketReply.prototype.setResult = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetMarketReply} returns this
 */
proto.market.GetMarketReply.prototype.clearResult = function() {
  return this.setResult(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketReply.prototype.hasResult = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string poolAddress = 2;
 * @return {string}
 */
proto.market.GetMarketReply.prototype.getPooladdress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.market.GetMarketReply} returns this
 */
proto.market.GetMarketReply.prototype.setPooladdress = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.market.GetMarketReply} returns this
 */
proto.market.GetMarketReply.prototype.clearPooladdress = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketReply.prototype.hasPooladdress = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string tokenAddress = 3;
 * @return {string}
 */
proto.market.GetMarketReply.prototype.getTokenaddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.market.GetMarketReply} returns this
 */
proto.market.GetMarketReply.prototype.setTokenaddress = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.market.GetMarketReply} returns this
 */
proto.market.GetMarketReply.prototype.clearTokenaddress = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketReply.prototype.hasTokenaddress = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string tokenName = 4;
 * @return {string}
 */
proto.market.GetMarketReply.prototype.getTokenname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.market.GetMarketReply} returns this
 */
proto.market.GetMarketReply.prototype.setTokenname = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.market.GetMarketReply} returns this
 */
proto.market.GetMarketReply.prototype.clearTokenname = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketReply.prototype.hasTokenname = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string tokenTicker = 5;
 * @return {string}
 */
proto.market.GetMarketReply.prototype.getTokenticker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.market.GetMarketReply} returns this
 */
proto.market.GetMarketReply.prototype.setTokenticker = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.market.GetMarketReply} returns this
 */
proto.market.GetMarketReply.prototype.clearTokenticker = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketReply.prototype.hasTokenticker = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional uint32 decimals = 6;
 * @return {number}
 */
proto.market.GetMarketReply.prototype.getDecimals = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.market.GetMarketReply} returns this
 */
proto.market.GetMarketReply.prototype.setDecimals = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.market.GetMarketReply} returns this
 */
proto.market.GetMarketReply.prototype.clearDecimals = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketReply.prototype.hasDecimals = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional common.Decimals price = 7;
 * @return {?proto.common.Decimals}
 */
proto.market.GetMarketReply.prototype.getPrice = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 7));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.GetMarketReply} returns this
*/
proto.market.GetMarketReply.prototype.setPrice = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetMarketReply} returns this
 */
proto.market.GetMarketReply.prototype.clearPrice = function() {
  return this.setPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketReply.prototype.hasPrice = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional enumeration.DexVersion dexVersion = 8;
 * @return {!proto.enumeration.DexVersion}
 */
proto.market.GetMarketReply.prototype.getDexversion = function() {
  return /** @type {!proto.enumeration.DexVersion} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.enumeration.DexVersion} value
 * @return {!proto.market.GetMarketReply} returns this
 */
proto.market.GetMarketReply.prototype.setDexversion = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.market.GetMarketReply} returns this
 */
proto.market.GetMarketReply.prototype.clearDexversion = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketReply.prototype.hasDexversion = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional common.AnalyticsReply analytics = 9;
 * @return {?proto.common.AnalyticsReply}
 */
proto.market.GetMarketReply.prototype.getAnalytics = function() {
  return /** @type{?proto.common.AnalyticsReply} */ (
    jspb.Message.getWrapperField(this, common_pb.AnalyticsReply, 9));
};


/**
 * @param {?proto.common.AnalyticsReply|undefined} value
 * @return {!proto.market.GetMarketReply} returns this
*/
proto.market.GetMarketReply.prototype.setAnalytics = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetMarketReply} returns this
 */
proto.market.GetMarketReply.prototype.clearAnalytics = function() {
  return this.setAnalytics(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketReply.prototype.hasAnalytics = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional common.AuditReply audit = 10;
 * @return {?proto.common.AuditReply}
 */
proto.market.GetMarketReply.prototype.getAudit = function() {
  return /** @type{?proto.common.AuditReply} */ (
    jspb.Message.getWrapperField(this, common_pb.AuditReply, 10));
};


/**
 * @param {?proto.common.AuditReply|undefined} value
 * @return {!proto.market.GetMarketReply} returns this
*/
proto.market.GetMarketReply.prototype.setAudit = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetMarketReply} returns this
 */
proto.market.GetMarketReply.prototype.clearAudit = function() {
  return this.setAudit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketReply.prototype.hasAudit = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional common.Tokenomics tokenomics = 11;
 * @return {?proto.common.Tokenomics}
 */
proto.market.GetMarketReply.prototype.getTokenomics = function() {
  return /** @type{?proto.common.Tokenomics} */ (
    jspb.Message.getWrapperField(this, common_pb.Tokenomics, 11));
};


/**
 * @param {?proto.common.Tokenomics|undefined} value
 * @return {!proto.market.GetMarketReply} returns this
*/
proto.market.GetMarketReply.prototype.setTokenomics = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetMarketReply} returns this
 */
proto.market.GetMarketReply.prototype.clearTokenomics = function() {
  return this.setTokenomics(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketReply.prototype.hasTokenomics = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional common.Decimals gasLimit = 12;
 * @return {?proto.common.Decimals}
 */
proto.market.GetMarketReply.prototype.getGaslimit = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 12));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.GetMarketReply} returns this
*/
proto.market.GetMarketReply.prototype.setGaslimit = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetMarketReply} returns this
 */
proto.market.GetMarketReply.prototype.clearGaslimit = function() {
  return this.setGaslimit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketReply.prototype.hasGaslimit = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional TokenLinks tokenLinks = 13;
 * @return {?proto.market.TokenLinks}
 */
proto.market.GetMarketReply.prototype.getTokenlinks = function() {
  return /** @type{?proto.market.TokenLinks} */ (
    jspb.Message.getWrapperField(this, proto.market.TokenLinks, 13));
};


/**
 * @param {?proto.market.TokenLinks|undefined} value
 * @return {!proto.market.GetMarketReply} returns this
*/
proto.market.GetMarketReply.prototype.setTokenlinks = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetMarketReply} returns this
 */
proto.market.GetMarketReply.prototype.clearTokenlinks = function() {
  return this.setTokenlinks(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetMarketReply.prototype.hasTokenlinks = function() {
  return jspb.Message.getField(this, 13) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.market.TokenLinks.prototype.toObject = function(opt_includeInstance) {
  return proto.market.TokenLinks.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.market.TokenLinks} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.TokenLinks.toObject = function(includeInstance, msg) {
  var f, obj = {
    twitter: jspb.Message.getFieldWithDefault(msg, 1, ""),
    website: jspb.Message.getFieldWithDefault(msg, 2, ""),
    telegram: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.market.TokenLinks}
 */
proto.market.TokenLinks.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.market.TokenLinks;
  return proto.market.TokenLinks.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.market.TokenLinks} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.market.TokenLinks}
 */
proto.market.TokenLinks.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTwitter(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setWebsite(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTelegram(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.market.TokenLinks.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.market.TokenLinks.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.market.TokenLinks} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.TokenLinks.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string twitter = 1;
 * @return {string}
 */
proto.market.TokenLinks.prototype.getTwitter = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.market.TokenLinks} returns this
 */
proto.market.TokenLinks.prototype.setTwitter = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.market.TokenLinks} returns this
 */
proto.market.TokenLinks.prototype.clearTwitter = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.TokenLinks.prototype.hasTwitter = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string website = 2;
 * @return {string}
 */
proto.market.TokenLinks.prototype.getWebsite = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.market.TokenLinks} returns this
 */
proto.market.TokenLinks.prototype.setWebsite = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.market.TokenLinks} returns this
 */
proto.market.TokenLinks.prototype.clearWebsite = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.TokenLinks.prototype.hasWebsite = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string telegram = 3;
 * @return {string}
 */
proto.market.TokenLinks.prototype.getTelegram = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.market.TokenLinks} returns this
 */
proto.market.TokenLinks.prototype.setTelegram = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.market.TokenLinks} returns this
 */
proto.market.TokenLinks.prototype.clearTelegram = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.TokenLinks.prototype.hasTelegram = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.market.GetKlinesRequest.oneofGroups_ = [[2,3]];

/**
 * @enum {number}
 */
proto.market.GetKlinesRequest.AddressCase = {
  ADDRESS_NOT_SET: 0,
  TOKENADDRESS: 2,
  POOLADDRESS: 3
};

/**
 * @return {proto.market.GetKlinesRequest.AddressCase}
 */
proto.market.GetKlinesRequest.prototype.getAddressCase = function() {
  return /** @type {proto.market.GetKlinesRequest.AddressCase} */(jspb.Message.computeOneofCase(this, proto.market.GetKlinesRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.market.GetKlinesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.market.GetKlinesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.market.GetKlinesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetKlinesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    chain: jspb.Message.getFieldWithDefault(msg, 1, 0),
    tokenaddress: jspb.Message.getFieldWithDefault(msg, 2, ""),
    pooladdress: jspb.Message.getFieldWithDefault(msg, 3, ""),
    interval: (f = msg.getInterval()) && common_pb.TimeInterval.toObject(includeInstance, f),
    starttime: (f = msg.getStarttime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    endtime: (f = msg.getEndtime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    limit: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.market.GetKlinesRequest}
 */
proto.market.GetKlinesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.market.GetKlinesRequest;
  return proto.market.GetKlinesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.market.GetKlinesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.market.GetKlinesRequest}
 */
proto.market.GetKlinesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.enumeration.Chain} */ (reader.readEnum());
      msg.setChain(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTokenaddress(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPooladdress(value);
      break;
    case 4:
      var value = new common_pb.TimeInterval;
      reader.readMessage(value,common_pb.TimeInterval.deserializeBinaryFromReader);
      msg.setInterval(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStarttime(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndtime(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.market.GetKlinesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.market.GetKlinesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.market.GetKlinesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetKlinesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChain();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getInterval();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.TimeInterval.serializeBinaryToWriter
    );
  }
  f = message.getStarttime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndtime();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeUint32(
      7,
      f
    );
  }
};


/**
 * optional enumeration.Chain chain = 1;
 * @return {!proto.enumeration.Chain}
 */
proto.market.GetKlinesRequest.prototype.getChain = function() {
  return /** @type {!proto.enumeration.Chain} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.enumeration.Chain} value
 * @return {!proto.market.GetKlinesRequest} returns this
 */
proto.market.GetKlinesRequest.prototype.setChain = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string tokenAddress = 2;
 * @return {string}
 */
proto.market.GetKlinesRequest.prototype.getTokenaddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.market.GetKlinesRequest} returns this
 */
proto.market.GetKlinesRequest.prototype.setTokenaddress = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.market.GetKlinesRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.market.GetKlinesRequest} returns this
 */
proto.market.GetKlinesRequest.prototype.clearTokenaddress = function() {
  return jspb.Message.setOneofField(this, 2, proto.market.GetKlinesRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetKlinesRequest.prototype.hasTokenaddress = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string poolAddress = 3;
 * @return {string}
 */
proto.market.GetKlinesRequest.prototype.getPooladdress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.market.GetKlinesRequest} returns this
 */
proto.market.GetKlinesRequest.prototype.setPooladdress = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.market.GetKlinesRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.market.GetKlinesRequest} returns this
 */
proto.market.GetKlinesRequest.prototype.clearPooladdress = function() {
  return jspb.Message.setOneofField(this, 3, proto.market.GetKlinesRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetKlinesRequest.prototype.hasPooladdress = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional common.TimeInterval interval = 4;
 * @return {?proto.common.TimeInterval}
 */
proto.market.GetKlinesRequest.prototype.getInterval = function() {
  return /** @type{?proto.common.TimeInterval} */ (
    jspb.Message.getWrapperField(this, common_pb.TimeInterval, 4));
};


/**
 * @param {?proto.common.TimeInterval|undefined} value
 * @return {!proto.market.GetKlinesRequest} returns this
*/
proto.market.GetKlinesRequest.prototype.setInterval = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetKlinesRequest} returns this
 */
proto.market.GetKlinesRequest.prototype.clearInterval = function() {
  return this.setInterval(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetKlinesRequest.prototype.hasInterval = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp startTime = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.market.GetKlinesRequest.prototype.getStarttime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.market.GetKlinesRequest} returns this
*/
proto.market.GetKlinesRequest.prototype.setStarttime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetKlinesRequest} returns this
 */
proto.market.GetKlinesRequest.prototype.clearStarttime = function() {
  return this.setStarttime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetKlinesRequest.prototype.hasStarttime = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Timestamp endTime = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.market.GetKlinesRequest.prototype.getEndtime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.market.GetKlinesRequest} returns this
*/
proto.market.GetKlinesRequest.prototype.setEndtime = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetKlinesRequest} returns this
 */
proto.market.GetKlinesRequest.prototype.clearEndtime = function() {
  return this.setEndtime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetKlinesRequest.prototype.hasEndtime = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional uint32 limit = 7;
 * @return {number}
 */
proto.market.GetKlinesRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.market.GetKlinesRequest} returns this
 */
proto.market.GetKlinesRequest.prototype.setLimit = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.market.GetKlinesRequest} returns this
 */
proto.market.GetKlinesRequest.prototype.clearLimit = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetKlinesRequest.prototype.hasLimit = function() {
  return jspb.Message.getField(this, 7) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.market.GetKlinesReply.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.market.GetKlinesReply.prototype.toObject = function(opt_includeInstance) {
  return proto.market.GetKlinesReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.market.GetKlinesReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetKlinesReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    result: (f = msg.getResult()) && common_pb.RequestResult.toObject(includeInstance, f),
    klinesList: jspb.Message.toObjectList(msg.getKlinesList(),
    proto.market.KlinesItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.market.GetKlinesReply}
 */
proto.market.GetKlinesReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.market.GetKlinesReply;
  return proto.market.GetKlinesReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.market.GetKlinesReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.market.GetKlinesReply}
 */
proto.market.GetKlinesReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_pb.RequestResult;
      reader.readMessage(value,common_pb.RequestResult.deserializeBinaryFromReader);
      msg.setResult(value);
      break;
    case 2:
      var value = new proto.market.KlinesItem;
      reader.readMessage(value,proto.market.KlinesItem.deserializeBinaryFromReader);
      msg.addKlines(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.market.GetKlinesReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.market.GetKlinesReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.market.GetKlinesReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetKlinesReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResult();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_pb.RequestResult.serializeBinaryToWriter
    );
  }
  f = message.getKlinesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.market.KlinesItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional common.RequestResult result = 1;
 * @return {?proto.common.RequestResult}
 */
proto.market.GetKlinesReply.prototype.getResult = function() {
  return /** @type{?proto.common.RequestResult} */ (
    jspb.Message.getWrapperField(this, common_pb.RequestResult, 1));
};


/**
 * @param {?proto.common.RequestResult|undefined} value
 * @return {!proto.market.GetKlinesReply} returns this
*/
proto.market.GetKlinesReply.prototype.setResult = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetKlinesReply} returns this
 */
proto.market.GetKlinesReply.prototype.clearResult = function() {
  return this.setResult(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetKlinesReply.prototype.hasResult = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated KlinesItem klines = 2;
 * @return {!Array<!proto.market.KlinesItem>}
 */
proto.market.GetKlinesReply.prototype.getKlinesList = function() {
  return /** @type{!Array<!proto.market.KlinesItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.market.KlinesItem, 2));
};


/**
 * @param {!Array<!proto.market.KlinesItem>} value
 * @return {!proto.market.GetKlinesReply} returns this
*/
proto.market.GetKlinesReply.prototype.setKlinesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.market.KlinesItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.market.KlinesItem}
 */
proto.market.GetKlinesReply.prototype.addKlines = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.market.KlinesItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.market.GetKlinesReply} returns this
 */
proto.market.GetKlinesReply.prototype.clearKlinesList = function() {
  return this.setKlinesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.market.KlinesItem.prototype.toObject = function(opt_includeInstance) {
  return proto.market.KlinesItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.market.KlinesItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.KlinesItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    opentime: (f = msg.getOpentime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    openprice: (f = msg.getOpenprice()) && common_pb.Decimals.toObject(includeInstance, f),
    highprice: (f = msg.getHighprice()) && common_pb.Decimals.toObject(includeInstance, f),
    lowprice: (f = msg.getLowprice()) && common_pb.Decimals.toObject(includeInstance, f),
    closeprice: (f = msg.getCloseprice()) && common_pb.Decimals.toObject(includeInstance, f),
    volumebase: (f = msg.getVolumebase()) && common_pb.Decimals.toObject(includeInstance, f),
    closetime: (f = msg.getClosetime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    volumequote: (f = msg.getVolumequote()) && common_pb.Decimals.toObject(includeInstance, f),
    count: jspb.Message.getFieldWithDefault(msg, 9, 0),
    isclosed: jspb.Message.getBooleanFieldWithDefault(msg, 10, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.market.KlinesItem}
 */
proto.market.KlinesItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.market.KlinesItem;
  return proto.market.KlinesItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.market.KlinesItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.market.KlinesItem}
 */
proto.market.KlinesItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setOpentime(value);
      break;
    case 2:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setOpenprice(value);
      break;
    case 3:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setHighprice(value);
      break;
    case 4:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setLowprice(value);
      break;
    case 5:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setCloseprice(value);
      break;
    case 6:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setVolumebase(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setClosetime(value);
      break;
    case 8:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setVolumequote(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCount(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsclosed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.market.KlinesItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.market.KlinesItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.market.KlinesItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.KlinesItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOpentime();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getOpenprice();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getHighprice();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getLowprice();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getCloseprice();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getVolumebase();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getClosetime();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getVolumequote();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeUint32(
      9,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeBool(
      10,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp openTime = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.market.KlinesItem.prototype.getOpentime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.market.KlinesItem} returns this
*/
proto.market.KlinesItem.prototype.setOpentime = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.KlinesItem} returns this
 */
proto.market.KlinesItem.prototype.clearOpentime = function() {
  return this.setOpentime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.KlinesItem.prototype.hasOpentime = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.Decimals openPrice = 2;
 * @return {?proto.common.Decimals}
 */
proto.market.KlinesItem.prototype.getOpenprice = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 2));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.KlinesItem} returns this
*/
proto.market.KlinesItem.prototype.setOpenprice = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.KlinesItem} returns this
 */
proto.market.KlinesItem.prototype.clearOpenprice = function() {
  return this.setOpenprice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.KlinesItem.prototype.hasOpenprice = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional common.Decimals highPrice = 3;
 * @return {?proto.common.Decimals}
 */
proto.market.KlinesItem.prototype.getHighprice = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 3));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.KlinesItem} returns this
*/
proto.market.KlinesItem.prototype.setHighprice = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.KlinesItem} returns this
 */
proto.market.KlinesItem.prototype.clearHighprice = function() {
  return this.setHighprice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.KlinesItem.prototype.hasHighprice = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional common.Decimals lowPrice = 4;
 * @return {?proto.common.Decimals}
 */
proto.market.KlinesItem.prototype.getLowprice = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 4));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.KlinesItem} returns this
*/
proto.market.KlinesItem.prototype.setLowprice = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.KlinesItem} returns this
 */
proto.market.KlinesItem.prototype.clearLowprice = function() {
  return this.setLowprice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.KlinesItem.prototype.hasLowprice = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional common.Decimals closePrice = 5;
 * @return {?proto.common.Decimals}
 */
proto.market.KlinesItem.prototype.getCloseprice = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 5));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.KlinesItem} returns this
*/
proto.market.KlinesItem.prototype.setCloseprice = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.KlinesItem} returns this
 */
proto.market.KlinesItem.prototype.clearCloseprice = function() {
  return this.setCloseprice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.KlinesItem.prototype.hasCloseprice = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional common.Decimals volumeBase = 6;
 * @return {?proto.common.Decimals}
 */
proto.market.KlinesItem.prototype.getVolumebase = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 6));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.KlinesItem} returns this
*/
proto.market.KlinesItem.prototype.setVolumebase = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.KlinesItem} returns this
 */
proto.market.KlinesItem.prototype.clearVolumebase = function() {
  return this.setVolumebase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.KlinesItem.prototype.hasVolumebase = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.Timestamp closeTime = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.market.KlinesItem.prototype.getClosetime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.market.KlinesItem} returns this
*/
proto.market.KlinesItem.prototype.setClosetime = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.KlinesItem} returns this
 */
proto.market.KlinesItem.prototype.clearClosetime = function() {
  return this.setClosetime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.KlinesItem.prototype.hasClosetime = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional common.Decimals volumeQuote = 8;
 * @return {?proto.common.Decimals}
 */
proto.market.KlinesItem.prototype.getVolumequote = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 8));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.KlinesItem} returns this
*/
proto.market.KlinesItem.prototype.setVolumequote = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.KlinesItem} returns this
 */
proto.market.KlinesItem.prototype.clearVolumequote = function() {
  return this.setVolumequote(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.KlinesItem.prototype.hasVolumequote = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional uint32 count = 9;
 * @return {number}
 */
proto.market.KlinesItem.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.market.KlinesItem} returns this
 */
proto.market.KlinesItem.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional bool isClosed = 10;
 * @return {boolean}
 */
proto.market.KlinesItem.prototype.getIsclosed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.market.KlinesItem} returns this
 */
proto.market.KlinesItem.prototype.setIsclosed = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.market.KlinesItem} returns this
 */
proto.market.KlinesItem.prototype.clearIsclosed = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.KlinesItem.prototype.hasIsclosed = function() {
  return jspb.Message.getField(this, 10) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.market.GetHoldersRequest.oneofGroups_ = [[2,3]];

/**
 * @enum {number}
 */
proto.market.GetHoldersRequest.AddressCase = {
  ADDRESS_NOT_SET: 0,
  TOKENADDRESS: 2,
  POOLADDRESS: 3
};

/**
 * @return {proto.market.GetHoldersRequest.AddressCase}
 */
proto.market.GetHoldersRequest.prototype.getAddressCase = function() {
  return /** @type {proto.market.GetHoldersRequest.AddressCase} */(jspb.Message.computeOneofCase(this, proto.market.GetHoldersRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.market.GetHoldersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.market.GetHoldersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.market.GetHoldersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetHoldersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    chain: jspb.Message.getFieldWithDefault(msg, 1, 0),
    tokenaddress: jspb.Message.getFieldWithDefault(msg, 2, ""),
    pooladdress: jspb.Message.getFieldWithDefault(msg, 3, ""),
    paging: (f = msg.getPaging()) && common_pb.KeyPagingRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.market.GetHoldersRequest}
 */
proto.market.GetHoldersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.market.GetHoldersRequest;
  return proto.market.GetHoldersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.market.GetHoldersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.market.GetHoldersRequest}
 */
proto.market.GetHoldersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.enumeration.Chain} */ (reader.readEnum());
      msg.setChain(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTokenaddress(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPooladdress(value);
      break;
    case 4:
      var value = new common_pb.KeyPagingRequest;
      reader.readMessage(value,common_pb.KeyPagingRequest.deserializeBinaryFromReader);
      msg.setPaging(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.market.GetHoldersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.market.GetHoldersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.market.GetHoldersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetHoldersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChain();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPaging();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.KeyPagingRequest.serializeBinaryToWriter
    );
  }
};


/**
 * optional enumeration.Chain chain = 1;
 * @return {!proto.enumeration.Chain}
 */
proto.market.GetHoldersRequest.prototype.getChain = function() {
  return /** @type {!proto.enumeration.Chain} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.enumeration.Chain} value
 * @return {!proto.market.GetHoldersRequest} returns this
 */
proto.market.GetHoldersRequest.prototype.setChain = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string tokenAddress = 2;
 * @return {string}
 */
proto.market.GetHoldersRequest.prototype.getTokenaddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.market.GetHoldersRequest} returns this
 */
proto.market.GetHoldersRequest.prototype.setTokenaddress = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.market.GetHoldersRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.market.GetHoldersRequest} returns this
 */
proto.market.GetHoldersRequest.prototype.clearTokenaddress = function() {
  return jspb.Message.setOneofField(this, 2, proto.market.GetHoldersRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetHoldersRequest.prototype.hasTokenaddress = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string poolAddress = 3;
 * @return {string}
 */
proto.market.GetHoldersRequest.prototype.getPooladdress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.market.GetHoldersRequest} returns this
 */
proto.market.GetHoldersRequest.prototype.setPooladdress = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.market.GetHoldersRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.market.GetHoldersRequest} returns this
 */
proto.market.GetHoldersRequest.prototype.clearPooladdress = function() {
  return jspb.Message.setOneofField(this, 3, proto.market.GetHoldersRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetHoldersRequest.prototype.hasPooladdress = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional common.KeyPagingRequest paging = 4;
 * @return {?proto.common.KeyPagingRequest}
 */
proto.market.GetHoldersRequest.prototype.getPaging = function() {
  return /** @type{?proto.common.KeyPagingRequest} */ (
    jspb.Message.getWrapperField(this, common_pb.KeyPagingRequest, 4));
};


/**
 * @param {?proto.common.KeyPagingRequest|undefined} value
 * @return {!proto.market.GetHoldersRequest} returns this
*/
proto.market.GetHoldersRequest.prototype.setPaging = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetHoldersRequest} returns this
 */
proto.market.GetHoldersRequest.prototype.clearPaging = function() {
  return this.setPaging(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetHoldersRequest.prototype.hasPaging = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.market.GetHoldersReply.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.market.GetHoldersReply.prototype.toObject = function(opt_includeInstance) {
  return proto.market.GetHoldersReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.market.GetHoldersReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetHoldersReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    result: (f = msg.getResult()) && common_pb.RequestResult.toObject(includeInstance, f),
    holdersList: jspb.Message.toObjectList(msg.getHoldersList(),
    proto.market.GetHoldersReplyItem.toObject, includeInstance),
    toremoveList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    continuationtoken: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.market.GetHoldersReply}
 */
proto.market.GetHoldersReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.market.GetHoldersReply;
  return proto.market.GetHoldersReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.market.GetHoldersReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.market.GetHoldersReply}
 */
proto.market.GetHoldersReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_pb.RequestResult;
      reader.readMessage(value,common_pb.RequestResult.deserializeBinaryFromReader);
      msg.setResult(value);
      break;
    case 2:
      var value = new proto.market.GetHoldersReplyItem;
      reader.readMessage(value,proto.market.GetHoldersReplyItem.deserializeBinaryFromReader);
      msg.addHolders(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addToremove(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setContinuationtoken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.market.GetHoldersReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.market.GetHoldersReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.market.GetHoldersReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetHoldersReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResult();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_pb.RequestResult.serializeBinaryToWriter
    );
  }
  f = message.getHoldersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.market.GetHoldersReplyItem.serializeBinaryToWriter
    );
  }
  f = message.getToremoveList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional common.RequestResult result = 1;
 * @return {?proto.common.RequestResult}
 */
proto.market.GetHoldersReply.prototype.getResult = function() {
  return /** @type{?proto.common.RequestResult} */ (
    jspb.Message.getWrapperField(this, common_pb.RequestResult, 1));
};


/**
 * @param {?proto.common.RequestResult|undefined} value
 * @return {!proto.market.GetHoldersReply} returns this
*/
proto.market.GetHoldersReply.prototype.setResult = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetHoldersReply} returns this
 */
proto.market.GetHoldersReply.prototype.clearResult = function() {
  return this.setResult(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetHoldersReply.prototype.hasResult = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated GetHoldersReplyItem holders = 2;
 * @return {!Array<!proto.market.GetHoldersReplyItem>}
 */
proto.market.GetHoldersReply.prototype.getHoldersList = function() {
  return /** @type{!Array<!proto.market.GetHoldersReplyItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.market.GetHoldersReplyItem, 2));
};


/**
 * @param {!Array<!proto.market.GetHoldersReplyItem>} value
 * @return {!proto.market.GetHoldersReply} returns this
*/
proto.market.GetHoldersReply.prototype.setHoldersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.market.GetHoldersReplyItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.market.GetHoldersReplyItem}
 */
proto.market.GetHoldersReply.prototype.addHolders = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.market.GetHoldersReplyItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.market.GetHoldersReply} returns this
 */
proto.market.GetHoldersReply.prototype.clearHoldersList = function() {
  return this.setHoldersList([]);
};


/**
 * repeated string toRemove = 3;
 * @return {!Array<string>}
 */
proto.market.GetHoldersReply.prototype.getToremoveList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.market.GetHoldersReply} returns this
 */
proto.market.GetHoldersReply.prototype.setToremoveList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.market.GetHoldersReply} returns this
 */
proto.market.GetHoldersReply.prototype.addToremove = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.market.GetHoldersReply} returns this
 */
proto.market.GetHoldersReply.prototype.clearToremoveList = function() {
  return this.setToremoveList([]);
};


/**
 * optional string continuationToken = 4;
 * @return {string}
 */
proto.market.GetHoldersReply.prototype.getContinuationtoken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.market.GetHoldersReply} returns this
 */
proto.market.GetHoldersReply.prototype.setContinuationtoken = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.market.GetHoldersReply} returns this
 */
proto.market.GetHoldersReply.prototype.clearContinuationtoken = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetHoldersReply.prototype.hasContinuationtoken = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.market.GetHoldersReplyItem.prototype.toObject = function(opt_includeInstance) {
  return proto.market.GetHoldersReplyItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.market.GetHoldersReplyItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetHoldersReplyItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    holderaddress: jspb.Message.getFieldWithDefault(msg, 1, ""),
    tokenamount: (f = msg.getTokenamount()) && common_pb.Decimals.toObject(includeInstance, f),
    tradevolume: (f = msg.getTradevolume()) && common_pb.Decimals.toObject(includeInstance, f),
    supply: (f = msg.getSupply()) && common_pb.Decimals.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.market.GetHoldersReplyItem}
 */
proto.market.GetHoldersReplyItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.market.GetHoldersReplyItem;
  return proto.market.GetHoldersReplyItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.market.GetHoldersReplyItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.market.GetHoldersReplyItem}
 */
proto.market.GetHoldersReplyItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setHolderaddress(value);
      break;
    case 2:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setTokenamount(value);
      break;
    case 3:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setTradevolume(value);
      break;
    case 4:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setSupply(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.market.GetHoldersReplyItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.market.GetHoldersReplyItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.market.GetHoldersReplyItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetHoldersReplyItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHolderaddress();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTokenamount();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getTradevolume();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getSupply();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
};


/**
 * optional string holderAddress = 1;
 * @return {string}
 */
proto.market.GetHoldersReplyItem.prototype.getHolderaddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.market.GetHoldersReplyItem} returns this
 */
proto.market.GetHoldersReplyItem.prototype.setHolderaddress = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional common.Decimals tokenAmount = 2;
 * @return {?proto.common.Decimals}
 */
proto.market.GetHoldersReplyItem.prototype.getTokenamount = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 2));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.GetHoldersReplyItem} returns this
*/
proto.market.GetHoldersReplyItem.prototype.setTokenamount = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetHoldersReplyItem} returns this
 */
proto.market.GetHoldersReplyItem.prototype.clearTokenamount = function() {
  return this.setTokenamount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetHoldersReplyItem.prototype.hasTokenamount = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional common.Decimals tradeVolume = 3;
 * @return {?proto.common.Decimals}
 */
proto.market.GetHoldersReplyItem.prototype.getTradevolume = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 3));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.GetHoldersReplyItem} returns this
*/
proto.market.GetHoldersReplyItem.prototype.setTradevolume = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetHoldersReplyItem} returns this
 */
proto.market.GetHoldersReplyItem.prototype.clearTradevolume = function() {
  return this.setTradevolume(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetHoldersReplyItem.prototype.hasTradevolume = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional common.Decimals supply = 4;
 * @return {?proto.common.Decimals}
 */
proto.market.GetHoldersReplyItem.prototype.getSupply = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 4));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.GetHoldersReplyItem} returns this
*/
proto.market.GetHoldersReplyItem.prototype.setSupply = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetHoldersReplyItem} returns this
 */
proto.market.GetHoldersReplyItem.prototype.clearSupply = function() {
  return this.setSupply(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetHoldersReplyItem.prototype.hasSupply = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.market.GetTransactionsRequest.oneofGroups_ = [[2,3]];

/**
 * @enum {number}
 */
proto.market.GetTransactionsRequest.AddressCase = {
  ADDRESS_NOT_SET: 0,
  TOKENADDRESS: 2,
  POOLADDRESS: 3
};

/**
 * @return {proto.market.GetTransactionsRequest.AddressCase}
 */
proto.market.GetTransactionsRequest.prototype.getAddressCase = function() {
  return /** @type {proto.market.GetTransactionsRequest.AddressCase} */(jspb.Message.computeOneofCase(this, proto.market.GetTransactionsRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.market.GetTransactionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.market.GetTransactionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.market.GetTransactionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetTransactionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    chain: jspb.Message.getFieldWithDefault(msg, 1, 0),
    tokenaddress: jspb.Message.getFieldWithDefault(msg, 2, ""),
    pooladdress: jspb.Message.getFieldWithDefault(msg, 3, ""),
    paging: (f = msg.getPaging()) && common_pb.KeyPagingRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.market.GetTransactionsRequest}
 */
proto.market.GetTransactionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.market.GetTransactionsRequest;
  return proto.market.GetTransactionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.market.GetTransactionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.market.GetTransactionsRequest}
 */
proto.market.GetTransactionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.enumeration.Chain} */ (reader.readEnum());
      msg.setChain(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTokenaddress(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPooladdress(value);
      break;
    case 4:
      var value = new common_pb.KeyPagingRequest;
      reader.readMessage(value,common_pb.KeyPagingRequest.deserializeBinaryFromReader);
      msg.setPaging(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.market.GetTransactionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.market.GetTransactionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.market.GetTransactionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetTransactionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChain();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPaging();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.KeyPagingRequest.serializeBinaryToWriter
    );
  }
};


/**
 * optional enumeration.Chain chain = 1;
 * @return {!proto.enumeration.Chain}
 */
proto.market.GetTransactionsRequest.prototype.getChain = function() {
  return /** @type {!proto.enumeration.Chain} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.enumeration.Chain} value
 * @return {!proto.market.GetTransactionsRequest} returns this
 */
proto.market.GetTransactionsRequest.prototype.setChain = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string tokenAddress = 2;
 * @return {string}
 */
proto.market.GetTransactionsRequest.prototype.getTokenaddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.market.GetTransactionsRequest} returns this
 */
proto.market.GetTransactionsRequest.prototype.setTokenaddress = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.market.GetTransactionsRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.market.GetTransactionsRequest} returns this
 */
proto.market.GetTransactionsRequest.prototype.clearTokenaddress = function() {
  return jspb.Message.setOneofField(this, 2, proto.market.GetTransactionsRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetTransactionsRequest.prototype.hasTokenaddress = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string poolAddress = 3;
 * @return {string}
 */
proto.market.GetTransactionsRequest.prototype.getPooladdress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.market.GetTransactionsRequest} returns this
 */
proto.market.GetTransactionsRequest.prototype.setPooladdress = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.market.GetTransactionsRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.market.GetTransactionsRequest} returns this
 */
proto.market.GetTransactionsRequest.prototype.clearPooladdress = function() {
  return jspb.Message.setOneofField(this, 3, proto.market.GetTransactionsRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetTransactionsRequest.prototype.hasPooladdress = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional common.KeyPagingRequest paging = 4;
 * @return {?proto.common.KeyPagingRequest}
 */
proto.market.GetTransactionsRequest.prototype.getPaging = function() {
  return /** @type{?proto.common.KeyPagingRequest} */ (
    jspb.Message.getWrapperField(this, common_pb.KeyPagingRequest, 4));
};


/**
 * @param {?proto.common.KeyPagingRequest|undefined} value
 * @return {!proto.market.GetTransactionsRequest} returns this
*/
proto.market.GetTransactionsRequest.prototype.setPaging = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetTransactionsRequest} returns this
 */
proto.market.GetTransactionsRequest.prototype.clearPaging = function() {
  return this.setPaging(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetTransactionsRequest.prototype.hasPaging = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.market.GetTransactionsReply.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.market.GetTransactionsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.market.GetTransactionsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.market.GetTransactionsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetTransactionsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    result: (f = msg.getResult()) && common_pb.RequestResult.toObject(includeInstance, f),
    transactionsList: jspb.Message.toObjectList(msg.getTransactionsList(),
    proto.market.GetTransactionsReplyItem.toObject, includeInstance),
    toremoveList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    continuationtoken: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.market.GetTransactionsReply}
 */
proto.market.GetTransactionsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.market.GetTransactionsReply;
  return proto.market.GetTransactionsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.market.GetTransactionsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.market.GetTransactionsReply}
 */
proto.market.GetTransactionsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_pb.RequestResult;
      reader.readMessage(value,common_pb.RequestResult.deserializeBinaryFromReader);
      msg.setResult(value);
      break;
    case 2:
      var value = new proto.market.GetTransactionsReplyItem;
      reader.readMessage(value,proto.market.GetTransactionsReplyItem.deserializeBinaryFromReader);
      msg.addTransactions(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addToremove(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setContinuationtoken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.market.GetTransactionsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.market.GetTransactionsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.market.GetTransactionsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetTransactionsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResult();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_pb.RequestResult.serializeBinaryToWriter
    );
  }
  f = message.getTransactionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.market.GetTransactionsReplyItem.serializeBinaryToWriter
    );
  }
  f = message.getToremoveList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional common.RequestResult result = 1;
 * @return {?proto.common.RequestResult}
 */
proto.market.GetTransactionsReply.prototype.getResult = function() {
  return /** @type{?proto.common.RequestResult} */ (
    jspb.Message.getWrapperField(this, common_pb.RequestResult, 1));
};


/**
 * @param {?proto.common.RequestResult|undefined} value
 * @return {!proto.market.GetTransactionsReply} returns this
*/
proto.market.GetTransactionsReply.prototype.setResult = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetTransactionsReply} returns this
 */
proto.market.GetTransactionsReply.prototype.clearResult = function() {
  return this.setResult(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetTransactionsReply.prototype.hasResult = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated GetTransactionsReplyItem transactions = 2;
 * @return {!Array<!proto.market.GetTransactionsReplyItem>}
 */
proto.market.GetTransactionsReply.prototype.getTransactionsList = function() {
  return /** @type{!Array<!proto.market.GetTransactionsReplyItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.market.GetTransactionsReplyItem, 2));
};


/**
 * @param {!Array<!proto.market.GetTransactionsReplyItem>} value
 * @return {!proto.market.GetTransactionsReply} returns this
*/
proto.market.GetTransactionsReply.prototype.setTransactionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.market.GetTransactionsReplyItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.market.GetTransactionsReplyItem}
 */
proto.market.GetTransactionsReply.prototype.addTransactions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.market.GetTransactionsReplyItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.market.GetTransactionsReply} returns this
 */
proto.market.GetTransactionsReply.prototype.clearTransactionsList = function() {
  return this.setTransactionsList([]);
};


/**
 * repeated string toRemove = 3;
 * @return {!Array<string>}
 */
proto.market.GetTransactionsReply.prototype.getToremoveList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.market.GetTransactionsReply} returns this
 */
proto.market.GetTransactionsReply.prototype.setToremoveList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.market.GetTransactionsReply} returns this
 */
proto.market.GetTransactionsReply.prototype.addToremove = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.market.GetTransactionsReply} returns this
 */
proto.market.GetTransactionsReply.prototype.clearToremoveList = function() {
  return this.setToremoveList([]);
};


/**
 * optional string continuationToken = 4;
 * @return {string}
 */
proto.market.GetTransactionsReply.prototype.getContinuationtoken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.market.GetTransactionsReply} returns this
 */
proto.market.GetTransactionsReply.prototype.setContinuationtoken = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.market.GetTransactionsReply} returns this
 */
proto.market.GetTransactionsReply.prototype.clearContinuationtoken = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetTransactionsReply.prototype.hasContinuationtoken = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.market.GetTransactionsReplyItem.prototype.toObject = function(opt_includeInstance) {
  return proto.market.GetTransactionsReplyItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.market.GetTransactionsReplyItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetTransactionsReplyItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    hash: jspb.Message.getFieldWithDefault(msg, 1, ""),
    completedat: (f = msg.getCompletedat()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    type: jspb.Message.getFieldWithDefault(msg, 3, 0),
    amount: (f = msg.getAmount()) && common_pb.Decimals.toObject(includeInstance, f),
    total: (f = msg.getTotal()) && common_pb.Decimals.toObject(includeInstance, f),
    creatoraddress: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.market.GetTransactionsReplyItem}
 */
proto.market.GetTransactionsReplyItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.market.GetTransactionsReplyItem;
  return proto.market.GetTransactionsReplyItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.market.GetTransactionsReplyItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.market.GetTransactionsReplyItem}
 */
proto.market.GetTransactionsReplyItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCompletedat(value);
      break;
    case 3:
      var value = /** @type {!proto.enumeration.TransactionType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 4:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setAmount(value);
      break;
    case 5:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setTotal(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatoraddress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.market.GetTransactionsReplyItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.market.GetTransactionsReplyItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.market.GetTransactionsReplyItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetTransactionsReplyItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCompletedat();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getAmount();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getCreatoraddress();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string hash = 1;
 * @return {string}
 */
proto.market.GetTransactionsReplyItem.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.market.GetTransactionsReplyItem} returns this
 */
proto.market.GetTransactionsReplyItem.prototype.setHash = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp completedAt = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.market.GetTransactionsReplyItem.prototype.getCompletedat = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.market.GetTransactionsReplyItem} returns this
*/
proto.market.GetTransactionsReplyItem.prototype.setCompletedat = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetTransactionsReplyItem} returns this
 */
proto.market.GetTransactionsReplyItem.prototype.clearCompletedat = function() {
  return this.setCompletedat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetTransactionsReplyItem.prototype.hasCompletedat = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional enumeration.TransactionType type = 3;
 * @return {!proto.enumeration.TransactionType}
 */
proto.market.GetTransactionsReplyItem.prototype.getType = function() {
  return /** @type {!proto.enumeration.TransactionType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.enumeration.TransactionType} value
 * @return {!proto.market.GetTransactionsReplyItem} returns this
 */
proto.market.GetTransactionsReplyItem.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional common.Decimals amount = 4;
 * @return {?proto.common.Decimals}
 */
proto.market.GetTransactionsReplyItem.prototype.getAmount = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 4));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.GetTransactionsReplyItem} returns this
*/
proto.market.GetTransactionsReplyItem.prototype.setAmount = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetTransactionsReplyItem} returns this
 */
proto.market.GetTransactionsReplyItem.prototype.clearAmount = function() {
  return this.setAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetTransactionsReplyItem.prototype.hasAmount = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional common.Decimals total = 5;
 * @return {?proto.common.Decimals}
 */
proto.market.GetTransactionsReplyItem.prototype.getTotal = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 5));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.GetTransactionsReplyItem} returns this
*/
proto.market.GetTransactionsReplyItem.prototype.setTotal = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetTransactionsReplyItem} returns this
 */
proto.market.GetTransactionsReplyItem.prototype.clearTotal = function() {
  return this.setTotal(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetTransactionsReplyItem.prototype.hasTotal = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string creatorAddress = 6;
 * @return {string}
 */
proto.market.GetTransactionsReplyItem.prototype.getCreatoraddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.market.GetTransactionsReplyItem} returns this
 */
proto.market.GetTransactionsReplyItem.prototype.setCreatoraddress = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.market.GetRatesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.market.GetRatesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.market.GetRatesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetRatesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    from: jspb.Message.getFieldWithDefault(msg, 1, ""),
    to: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.market.GetRatesRequest}
 */
proto.market.GetRatesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.market.GetRatesRequest;
  return proto.market.GetRatesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.market.GetRatesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.market.GetRatesRequest}
 */
proto.market.GetRatesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFrom(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.market.GetRatesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.market.GetRatesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.market.GetRatesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetRatesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrom();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTo();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string from = 1;
 * @return {string}
 */
proto.market.GetRatesRequest.prototype.getFrom = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.market.GetRatesRequest} returns this
 */
proto.market.GetRatesRequest.prototype.setFrom = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string to = 2;
 * @return {string}
 */
proto.market.GetRatesRequest.prototype.getTo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.market.GetRatesRequest} returns this
 */
proto.market.GetRatesRequest.prototype.setTo = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.market.GetRatesReply.prototype.toObject = function(opt_includeInstance) {
  return proto.market.GetRatesReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.market.GetRatesReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetRatesReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    result: (f = msg.getResult()) && common_pb.RequestResult.toObject(includeInstance, f),
    rate: (f = msg.getRate()) && common_pb.Decimals.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.market.GetRatesReply}
 */
proto.market.GetRatesReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.market.GetRatesReply;
  return proto.market.GetRatesReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.market.GetRatesReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.market.GetRatesReply}
 */
proto.market.GetRatesReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_pb.RequestResult;
      reader.readMessage(value,common_pb.RequestResult.deserializeBinaryFromReader);
      msg.setResult(value);
      break;
    case 2:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setRate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.market.GetRatesReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.market.GetRatesReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.market.GetRatesReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetRatesReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResult();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_pb.RequestResult.serializeBinaryToWriter
    );
  }
  f = message.getRate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
};


/**
 * optional common.RequestResult result = 1;
 * @return {?proto.common.RequestResult}
 */
proto.market.GetRatesReply.prototype.getResult = function() {
  return /** @type{?proto.common.RequestResult} */ (
    jspb.Message.getWrapperField(this, common_pb.RequestResult, 1));
};


/**
 * @param {?proto.common.RequestResult|undefined} value
 * @return {!proto.market.GetRatesReply} returns this
*/
proto.market.GetRatesReply.prototype.setResult = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetRatesReply} returns this
 */
proto.market.GetRatesReply.prototype.clearResult = function() {
  return this.setResult(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetRatesReply.prototype.hasResult = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.Decimals rate = 2;
 * @return {?proto.common.Decimals}
 */
proto.market.GetRatesReply.prototype.getRate = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 2));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.GetRatesReply} returns this
*/
proto.market.GetRatesReply.prototype.setRate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetRatesReply} returns this
 */
proto.market.GetRatesReply.prototype.clearRate = function() {
  return this.setRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetRatesReply.prototype.hasRate = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.market.GetGasPriceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.market.GetGasPriceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.market.GetGasPriceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetGasPriceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    chain: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.market.GetGasPriceRequest}
 */
proto.market.GetGasPriceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.market.GetGasPriceRequest;
  return proto.market.GetGasPriceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.market.GetGasPriceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.market.GetGasPriceRequest}
 */
proto.market.GetGasPriceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.enumeration.Chain} */ (reader.readEnum());
      msg.setChain(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.market.GetGasPriceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.market.GetGasPriceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.market.GetGasPriceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetGasPriceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChain();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional enumeration.Chain chain = 1;
 * @return {!proto.enumeration.Chain}
 */
proto.market.GetGasPriceRequest.prototype.getChain = function() {
  return /** @type {!proto.enumeration.Chain} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.enumeration.Chain} value
 * @return {!proto.market.GetGasPriceRequest} returns this
 */
proto.market.GetGasPriceRequest.prototype.setChain = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.market.GetGasPriceReply.prototype.toObject = function(opt_includeInstance) {
  return proto.market.GetGasPriceReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.market.GetGasPriceReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetGasPriceReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    result: (f = msg.getResult()) && common_pb.RequestResult.toObject(includeInstance, f),
    price: (f = msg.getPrice()) && common_pb.Decimals.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.market.GetGasPriceReply}
 */
proto.market.GetGasPriceReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.market.GetGasPriceReply;
  return proto.market.GetGasPriceReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.market.GetGasPriceReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.market.GetGasPriceReply}
 */
proto.market.GetGasPriceReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_pb.RequestResult;
      reader.readMessage(value,common_pb.RequestResult.deserializeBinaryFromReader);
      msg.setResult(value);
      break;
    case 2:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setPrice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.market.GetGasPriceReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.market.GetGasPriceReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.market.GetGasPriceReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.GetGasPriceReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResult();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_pb.RequestResult.serializeBinaryToWriter
    );
  }
  f = message.getPrice();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
};


/**
 * optional common.RequestResult result = 1;
 * @return {?proto.common.RequestResult}
 */
proto.market.GetGasPriceReply.prototype.getResult = function() {
  return /** @type{?proto.common.RequestResult} */ (
    jspb.Message.getWrapperField(this, common_pb.RequestResult, 1));
};


/**
 * @param {?proto.common.RequestResult|undefined} value
 * @return {!proto.market.GetGasPriceReply} returns this
*/
proto.market.GetGasPriceReply.prototype.setResult = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetGasPriceReply} returns this
 */
proto.market.GetGasPriceReply.prototype.clearResult = function() {
  return this.setResult(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetGasPriceReply.prototype.hasResult = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.Decimals price = 2;
 * @return {?proto.common.Decimals}
 */
proto.market.GetGasPriceReply.prototype.getPrice = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 2));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.GetGasPriceReply} returns this
*/
proto.market.GetGasPriceReply.prototype.setPrice = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.GetGasPriceReply} returns this
 */
proto.market.GetGasPriceReply.prototype.clearPrice = function() {
  return this.setPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.GetGasPriceReply.prototype.hasPrice = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.market.SearchMarketsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.market.SearchMarketsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.market.SearchMarketsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.SearchMarketsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    chain: jspb.Message.getFieldWithDefault(msg, 1, 0),
    search: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.market.SearchMarketsRequest}
 */
proto.market.SearchMarketsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.market.SearchMarketsRequest;
  return proto.market.SearchMarketsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.market.SearchMarketsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.market.SearchMarketsRequest}
 */
proto.market.SearchMarketsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.enumeration.Chain} */ (reader.readEnum());
      msg.setChain(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearch(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.market.SearchMarketsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.market.SearchMarketsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.market.SearchMarketsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.SearchMarketsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChain();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getSearch();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional enumeration.Chain chain = 1;
 * @return {!proto.enumeration.Chain}
 */
proto.market.SearchMarketsRequest.prototype.getChain = function() {
  return /** @type {!proto.enumeration.Chain} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.enumeration.Chain} value
 * @return {!proto.market.SearchMarketsRequest} returns this
 */
proto.market.SearchMarketsRequest.prototype.setChain = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string search = 2;
 * @return {string}
 */
proto.market.SearchMarketsRequest.prototype.getSearch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.market.SearchMarketsRequest} returns this
 */
proto.market.SearchMarketsRequest.prototype.setSearch = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.market.SearchMarketsReply.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.market.SearchMarketsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.market.SearchMarketsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.market.SearchMarketsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.SearchMarketsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    result: (f = msg.getResult()) && common_pb.RequestResult.toObject(includeInstance, f),
    searchresultsList: jspb.Message.toObjectList(msg.getSearchresultsList(),
    proto.market.SearchMarketsReplyItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.market.SearchMarketsReply}
 */
proto.market.SearchMarketsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.market.SearchMarketsReply;
  return proto.market.SearchMarketsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.market.SearchMarketsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.market.SearchMarketsReply}
 */
proto.market.SearchMarketsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_pb.RequestResult;
      reader.readMessage(value,common_pb.RequestResult.deserializeBinaryFromReader);
      msg.setResult(value);
      break;
    case 2:
      var value = new proto.market.SearchMarketsReplyItem;
      reader.readMessage(value,proto.market.SearchMarketsReplyItem.deserializeBinaryFromReader);
      msg.addSearchresults(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.market.SearchMarketsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.market.SearchMarketsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.market.SearchMarketsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.SearchMarketsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResult();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_pb.RequestResult.serializeBinaryToWriter
    );
  }
  f = message.getSearchresultsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.market.SearchMarketsReplyItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional common.RequestResult result = 1;
 * @return {?proto.common.RequestResult}
 */
proto.market.SearchMarketsReply.prototype.getResult = function() {
  return /** @type{?proto.common.RequestResult} */ (
    jspb.Message.getWrapperField(this, common_pb.RequestResult, 1));
};


/**
 * @param {?proto.common.RequestResult|undefined} value
 * @return {!proto.market.SearchMarketsReply} returns this
*/
proto.market.SearchMarketsReply.prototype.setResult = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.SearchMarketsReply} returns this
 */
proto.market.SearchMarketsReply.prototype.clearResult = function() {
  return this.setResult(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.SearchMarketsReply.prototype.hasResult = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated SearchMarketsReplyItem searchResults = 2;
 * @return {!Array<!proto.market.SearchMarketsReplyItem>}
 */
proto.market.SearchMarketsReply.prototype.getSearchresultsList = function() {
  return /** @type{!Array<!proto.market.SearchMarketsReplyItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.market.SearchMarketsReplyItem, 2));
};


/**
 * @param {!Array<!proto.market.SearchMarketsReplyItem>} value
 * @return {!proto.market.SearchMarketsReply} returns this
*/
proto.market.SearchMarketsReply.prototype.setSearchresultsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.market.SearchMarketsReplyItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.market.SearchMarketsReplyItem}
 */
proto.market.SearchMarketsReply.prototype.addSearchresults = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.market.SearchMarketsReplyItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.market.SearchMarketsReply} returns this
 */
proto.market.SearchMarketsReply.prototype.clearSearchresultsList = function() {
  return this.setSearchresultsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.market.SearchMarketsReplyItem.prototype.toObject = function(opt_includeInstance) {
  return proto.market.SearchMarketsReplyItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.market.SearchMarketsReplyItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.SearchMarketsReplyItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    tokenaddress: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pooladdress: jspb.Message.getFieldWithDefault(msg, 2, ""),
    tokenname: jspb.Message.getFieldWithDefault(msg, 3, ""),
    tokenticker: jspb.Message.getFieldWithDefault(msg, 4, ""),
    price: (f = msg.getPrice()) && common_pb.Decimals.toObject(includeInstance, f),
    pricechangepct: (f = msg.getPricechangepct()) && common_pb.Decimals.toObject(includeInstance, f),
    createdat: jspb.Message.getFieldWithDefault(msg, 7, ""),
    liquidity: (f = msg.getLiquidity()) && common_pb.Decimals.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.market.SearchMarketsReplyItem}
 */
proto.market.SearchMarketsReplyItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.market.SearchMarketsReplyItem;
  return proto.market.SearchMarketsReplyItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.market.SearchMarketsReplyItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.market.SearchMarketsReplyItem}
 */
proto.market.SearchMarketsReplyItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTokenaddress(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPooladdress(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTokenname(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTokenticker(value);
      break;
    case 5:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setPrice(value);
      break;
    case 6:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setPricechangepct(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedat(value);
      break;
    case 8:
      var value = new common_pb.Decimals;
      reader.readMessage(value,common_pb.Decimals.deserializeBinaryFromReader);
      msg.setLiquidity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.market.SearchMarketsReplyItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.market.SearchMarketsReplyItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.market.SearchMarketsReplyItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.market.SearchMarketsReplyItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTokenaddress();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPooladdress();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTokenname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTokenticker();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPrice();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getPricechangepct();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getCreatedat();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getLiquidity();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      common_pb.Decimals.serializeBinaryToWriter
    );
  }
};


/**
 * optional string tokenAddress = 1;
 * @return {string}
 */
proto.market.SearchMarketsReplyItem.prototype.getTokenaddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.market.SearchMarketsReplyItem} returns this
 */
proto.market.SearchMarketsReplyItem.prototype.setTokenaddress = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string poolAddress = 2;
 * @return {string}
 */
proto.market.SearchMarketsReplyItem.prototype.getPooladdress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.market.SearchMarketsReplyItem} returns this
 */
proto.market.SearchMarketsReplyItem.prototype.setPooladdress = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string tokenName = 3;
 * @return {string}
 */
proto.market.SearchMarketsReplyItem.prototype.getTokenname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.market.SearchMarketsReplyItem} returns this
 */
proto.market.SearchMarketsReplyItem.prototype.setTokenname = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string tokenTicker = 4;
 * @return {string}
 */
proto.market.SearchMarketsReplyItem.prototype.getTokenticker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.market.SearchMarketsReplyItem} returns this
 */
proto.market.SearchMarketsReplyItem.prototype.setTokenticker = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional common.Decimals price = 5;
 * @return {?proto.common.Decimals}
 */
proto.market.SearchMarketsReplyItem.prototype.getPrice = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 5));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.SearchMarketsReplyItem} returns this
*/
proto.market.SearchMarketsReplyItem.prototype.setPrice = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.SearchMarketsReplyItem} returns this
 */
proto.market.SearchMarketsReplyItem.prototype.clearPrice = function() {
  return this.setPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.SearchMarketsReplyItem.prototype.hasPrice = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional common.Decimals priceChangePct = 6;
 * @return {?proto.common.Decimals}
 */
proto.market.SearchMarketsReplyItem.prototype.getPricechangepct = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 6));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.SearchMarketsReplyItem} returns this
*/
proto.market.SearchMarketsReplyItem.prototype.setPricechangepct = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.SearchMarketsReplyItem} returns this
 */
proto.market.SearchMarketsReplyItem.prototype.clearPricechangepct = function() {
  return this.setPricechangepct(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.SearchMarketsReplyItem.prototype.hasPricechangepct = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string createdAt = 7;
 * @return {string}
 */
proto.market.SearchMarketsReplyItem.prototype.getCreatedat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.market.SearchMarketsReplyItem} returns this
 */
proto.market.SearchMarketsReplyItem.prototype.setCreatedat = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional common.Decimals liquidity = 8;
 * @return {?proto.common.Decimals}
 */
proto.market.SearchMarketsReplyItem.prototype.getLiquidity = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, common_pb.Decimals, 8));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.market.SearchMarketsReplyItem} returns this
*/
proto.market.SearchMarketsReplyItem.prototype.setLiquidity = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.market.SearchMarketsReplyItem} returns this
 */
proto.market.SearchMarketsReplyItem.prototype.clearLiquidity = function() {
  return this.setLiquidity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.market.SearchMarketsReplyItem.prototype.hasLiquidity = function() {
  return jspb.Message.getField(this, 8) != null;
};


goog.object.extend(exports, proto.market);
